export default "__VITE_ASSET__CnSs4Qyq__"